<template>
    <modal id="mapSettingsModal" width="lg" :dark-mode="darkModeEnabled">
        <span slot="header">General Settings</span>
        <div slot="body">

            <div class="flex">
                <div class="w-1/3 flex flex-col pr-5">
                    <button class="border-blue-dark inline-block border rounded py-3 px-3 no-underline mb-2 no-outline" :class="{'bg-blue-dark text-white': selectedSetting == 'general', 'text-blue-dark': selectedSetting !== 'general'}" v-on:click="toggle('general')">General Settings</button>
                    <button class="border-blue-dark inline-block border rounded py-3 px-3 no-underline mb-2 no-outline" :class="{'bg-blue-dark text-white': selectedSetting == 'map', 'text-blue-dark': selectedSetting !== 'map'}" v-on:click="toggle('map')">Map Settings</button>
                    <button class="border-blue-dark inline-block border rounded py-3 px-3 no-underline mb-2 no-outline" :class="{'bg-blue-dark text-white': selectedSetting == 'radar', 'text-blue-dark': selectedSetting !== 'radar'}" v-on:click="toggle('radar')">Radar Settings</button>
                    <button class="border-blue-dark inline-block border rounded py-3 px-3 no-underline mb-2 no-outline" :class="{'bg-blue-dark text-white': selectedSetting == 'alert', 'text-blue-dark': selectedSetting !== 'alert'}" v-on:click="toggle('alert')">Alert Settings</button>
                    <button class="border-blue-dark inline-block border rounded py-3 px-3 no-underline mb-2 no-outline" :class="{'bg-blue-dark text-white': selectedSetting == 'clearSettings', 'text-blue-dark': selectedSetting !== 'clearSettings'}" v-on:click="toggle('clearSettings')">Clear Local Storage</button>
                </div>
                <div class="w-2/3">
                    <div class="w-full max-w-md" v-if="selectedSetting == 'general'">
                        <div>
                            <h4 :class="{'text-white': darkModeEnabled}">Site Theme</h4>
                            <p class="text-grey-darker text-sm pt-1">Selecting 'dark mode' makes naturally bright elements darker. This can help for you basement dweller arm-chair chasers, or arm-chair chasing after the sun sets!</p>
                            <div class="md:w-full py-4 md:flex md:flex-wrap justify-center">
                                <custom-radio-button element-name="Normal" :element-value="false" v-model="darkModeEnabled"></custom-radio-button>
                                <custom-radio-button element-name="Dark Mode" :element-value="true" v-model="darkModeEnabled"></custom-radio-button>
                            </div>
                        </div>
                    </div>

                    <!-- Mao Settings -->
                    <div class="w-full max-w-md" v-if="selectedSetting == 'map'">
                        <div>
                            <h4 :class="{'text-white': darkModeEnabled}">City Visibility</h4>
                            <div class="md:w-full py-4 md:flex md:flex-wrap justify-center">
                                <custom-radio-button element-name="Below Layer" :element-picture="require('@/assets/images/settings/cities.png')" :element-value="false" v-model="citiesAboveLayer"></custom-radio-button>
                                <custom-radio-button element-name="Above Layer" :element-picture="require('@/assets/images/settings/roads.png')" :element-value="true" v-model="citiesAboveLayer"></custom-radio-button>
                            </div>
                        </div>

                        <div class="mt-4">
                            <h4 :class="{'text-white': darkModeEnabled}">Map Style</h4>
                            <div class="md:w-full py-4 md:flex md:flex-wrap justify-center">
                                <custom-radio-button element-name="Light" :element-picture="require('@/assets/images/settings/light.png')" :element-value="false" v-model="isMapDark"></custom-radio-button>
                                <custom-radio-button element-name="Dark" :element-picture="require('@/assets/images/settings/dark.png')" :element-value="true" v-model="isMapDark"></custom-radio-button>
                            </div>
                        </div>

                        <div class="mt-4">
                            <h4 :class="{'text-white': darkModeEnabled}">Overlay Settings</h4>
                            <div class="md:w-full py-4 md:flex md:flex-wrap justify-center">
                                <custom-radio-button element-name="Smoothed" :element-picture="require('@/assets/images/settings/radar-smoothed.png')" :element-value="false" v-model="rawDataEnabled"></custom-radio-button>
                                <custom-radio-button element-name="Raw" :element-picture="require('@/assets/images/settings/radar-unsmoothed.png')" :element-value="true" v-model="rawDataEnabled"></custom-radio-button>
                            </div>
                        </div>

                    </div>

                    <div class="w-full max-w-md" v-if="selectedSetting == 'radar'">radar</div>

                    <div class="w-full max-w-md" v-if="selectedSetting == 'alert'">alert</div>

                    <div class="w-full max-w-md" v-if="selectedSetting == 'clearSettings'">
                        <h4 :class="{'text-white': darkModeEnabled}">Clear all Local Storage</h4>
                        <p class="text-grey-darker text-sm pt-1">Performing the following action will remove all of your local settings, which includes map ordering, map settings, and all account information stored on your browser. You will need to sign back in after performing this action.</p>
                        <div class="md:w-full md:flex justify-center">
                            <button class="bg-red-dark text-white text-sm font-bold py-3 px-4 rounded mt-5 no-outline" v-on:click="clearSettings">
                                Clear Local Storage
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            <!-- <button @click="test()" class="bg-blue-dark text-white font-bold py-4 px-6 rounded w-full mt-10 no-outline">
                Update Map Settings
            </button> -->
        </div>
    </modal>
</template>

<script>
    import Modal from '@/components/Modal';
    import CustomRadioButton from '@/components/CustomRadioButton';
    import { EventBus } from '@/events';


    export default {
        name: 'mapSettingsModal',
        data() {
            return {
                selectedSetting: 'general',
                darkModeEnabled: false,
                citiesAboveLayer: true,
                isMapDark: false,
                rawDataEnabled: true,
            }
        },
        watch: {
            darkModeEnabled: function(val) {
                if(val == true) {
                    this.isMapDark = true
                }
                localStorage.darkModeEnabled = val
            },
            isMapDark: function(val) {
                if(val == true) {
                    this.$store.state.map.setStyle('https://maps.tilehosting.com/styles/darkmatter/style.json?key=F0jV6BWhVz3rAis5y6DM');
                } else {
                    this.$store.state.map.setStyle('https://maps.tilehosting.com/styles/positron/style.json?key=F0jV6BWhVz3rAis5y6DM');
                }
                localStorage.isMapDark = val
            },
            citiesAboveLayer: function(val) {
                // true = cities are above layer
                if(val == true) {
                    this.$store.state.map.moveLayer('radar', 'railway')
                } else {
                    this.$store.state.map.moveLayer('radar', '')
                }
                localStorage.citiesAboveLayer = val
            },
            rawDataEnabled: function(val) {
                localStorage.rawDataEnabled = val
                this.addRadarToMap(val)
            }
        },
        mounted() {
            if (localStorage.darkModeEnabled) {
                this.darkModeEnabled = JSON.parse(localStorage.darkModeEnabled);
            }
            if (localStorage.citiesAboveLayer) {
                this.citiesAboveLayer = JSON.parse(localStorage.citiesAboveLayer);
            }
            if (localStorage.isMapDark) {
                this.isMapDark = JSON.parse(localStorage.isMapDark);
            }
            if (localStorage.rawDataEnabled) {
                this.rawDataEnabled = JSON.parse(localStorage.rawDataEnabled)
            }
        },
        components: {
            'modal': Modal,
            CustomRadioButton
        },
        methods: {
            toggle(item) {
                this.selectedSetting = item
            },
            clearSettings() {
                localStorage.clear();
                window.alert('All local storage successfully cleared.')
            },
            addRadarToMap(status) {
                var _this = this;
                if(this.$store.state.map.getLayer('radar')) {
                    this.$store.state.map.removeLayer('radar')
                    this.$store.state.map.removeSource('radar')
                }


                this.$http.get("https://weather-tiling-api.wxdata.io/data/current/1/current").then((response) => {

                    let radarData = response.data
                    var source =  "https://tiles.wxdata.io/tileserver/radar/" + radarData.identifier + "/{z}/{x}/{y}.png"

                    if(status == false) {
                        source = "https://tiles.wxdata.io/tileserver/radar/" + radarData.identifier + "_smoothed/{z}/{x}/{y}.png"
                    }

                    this.$store.state.map.addLayer({
                        'id': 'radar',
                        'type': 'raster',
                        'source': {
                            'type': 'raster',
                            'tiles': [
                                source
                            ],
                            'tileSize': 256,
                        },
                        'paint': {
                            'raster-opacity': 0.6,
                        }
                    }, this.$MapHelpers.determineLayerPlacement(this.$store.state.map, 'radar'));
                    
                });
                
            },

        }
    }
</script>

<style>
    .bg-smoke-dark {
        background-color: rgba(0,0,0,.5);
    }

    .no-outline:focus {
        outline:0;
    }
</style>
